import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaFolderPlus, FaUsers, FaExchangeAlt, FaThLarge } from 'react-icons/fa';
import { mockWorkspaces } from '../components/mockAdCreatorData'; // Adjusted import path
import { Workspace, AdProject } from '../components/adCreatorTypes'; // Adjusted import path

const AdCreatorDashboardPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const currentWorkspace: Workspace | undefined = mockWorkspaces[0];
  const adProjects: AdProject[] = currentWorkspace?.adProjects || [];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const menuOptions = [
    { name: 'Create WorkSpace', icon: <FaFolderPlus className="mr-2" /> },
    { name: 'Manage Members', icon: <FaUsers className="mr-2" /> },
    { name: 'Switch WorkSpace', icon: <FaExchangeAlt className="mr-2" /> },
    { name: 'All WorkSpaces', icon: <FaThLarge className="mr-2" /> },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-dark text-white p-4 flex justify-between items-center">
        <div className="relative">
          <button onClick={toggleMenu} className="p-2 rounded hover:bg-gray-700">
            <FaBars size={24} />
          </button>
          {isMenuOpen && (
            <div className="absolute left-0 mt-2 w-64 bg-white text-gray-800 rounded-md shadow-lg py-2 z-50">
              {menuOptions.map(opt => (
                <a
                  key={opt.name}
                  href="#" // Placeholder links
                  className="flex items-center px-4 py-2 text-sm hover:bg-gray-100"
                >
                  {opt.icon} {opt.name}
                </a>
              ))}
            </div>
          )}
        </div>
        <h1 className="text-xl font-semibold">Ad Creator Dashboard</h1>
        <div>{/* User Profile / Settings Icon can go here */}</div>
      </header>

      <main className="p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Ads in{' '}
          <span className="font-bold text-primary">
            {currentWorkspace?.name || 'Current Workspace'}
          </span>
        </h2>
        {adProjects.length === 0 ? (
          <p className="text-gray-600">
            No ad projects in this workspace yet.{' '}
            <Link to="#" className="text-primary hover:underline">
              Create one!
            </Link>
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {adProjects.map(ad => (
              <Link
                key={ad.id}
                to={`/creator/editor/${ad.id}`}
                className="block bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
              >
                <div className="w-full h-40 bg-gray-300 flex items-center justify-center">
                  {ad.heroImage ? (
                    <img
                      src={ad.heroImage}
                      alt={ad.name}
                      className="w-full h-full object-cover"
                      onError={e => (e.currentTarget.style.display = 'none')}
                    />
                  ) : (
                    <span className="text-gray-500">No Preview</span>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800 truncate" title={ad.name}>
                    {ad.name}
                  </h3>
                  {ad.description && (
                    <p className="text-sm text-gray-600 mt-1 truncate" title={ad.description}>
                      {ad.description}
                    </p>
                  )}
                  <p className="text-xs text-gray-400 mt-2">
                    Updated: {new Date(ad.updatedAt).toLocaleDateString()}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default AdCreatorDashboardPage;
